import { useState } from 'react';
import { useCompleteCartPaypal } from '../../../services';

export const usePaypalCheckoutCompletePayment = (
  cartClientId: string | undefined
) => {
  const [paypalError, setPaypalError] = useState(null);
  const [paypalProcessing, setPaypalProcessing] = useState(false);
  const [paypalComplete, setComplete] = useState(false);

  const submitPaypalComplete = () => {
    const completePaypal = useCompleteCartPaypal(cartClientId);
    setPaypalProcessing(true);

    completePaypal.then((complete: any) => {
      if (complete?.dataResponse?.success) {
        setComplete(true);
      } else {
        setPaypalError(complete.error.message);
      }
      setPaypalProcessing(false);
    });
  };

  return {
    paypalError,
    setPaypalError,
    paypalProcessing,
    setPaypalProcessing,
    paypalComplete,
    submitPaypalComplete,
  };
};
